module.exports = __webpack_public_path__ + "41af3251adc06f85d420f512501477da.svg";